export default __webpack_public_path__ + "images/defaultBanner.3a8afb15417b12173238535555ad4535.jpg";